// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"group-landing-page-cta-module--cta-wrapper--94d33","groupLandingCta":"group-landing-page-cta-module--group-landing-cta--ad983"};